export default "__VITE_ASSET__BMnvwwPD__"